<template>
  <b-modal
      :ref="name"
      :title="title"
      cancel-title="Close"
      ok-only
      size="md"
      @close="close"
      @ok="close"
  >
    <template #modal-header>
      <div class="w-100">
        <h4 class="float-left">{{ $t('modal.title.edit_dictionary') }}</h4>
      </div>
    </template>
    <b-form>

      <b-form-group id="input-group-2" :label="$t('form.label.dictionary_alias')" label-for="input-2">
        <b-form-input
            id="input-2"
            v-model="form.name"
            :placeholder="$t('form.placeholder.dictionary_alias')"
            required
        ></b-form-input>
      </b-form-group>

      <b-form-checkbox
          id="checkbox-1"
          v-model="form.active"
          name="checkbox-1"
          :value="true"
          unchecked-value="not_accepted"
      >
        {{$t('form.label.is_active')}}
      </b-form-checkbox>

    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <div class="buttons float-right">
          <b-button type="button" variant="secondary" class="mr-2" @click="close">{{ $t('btn.cancel') }}</b-button>
          <b-button variant="primary"  :disabled="busy" @click="submit">
            <div v-if="busy">
              <b-spinner small type="grow"></b-spinner>
              {{ $t('btn.state.saving') }}
            </div>
            <div v-else>
              {{ $t('btn.save') }}
            </div>
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>

</template>

<script>

import axios from "axios";

export default {
  props: {},
  data() {
    return {
      name: 'default-modal',
      title: '',
      busy: false,
      form: {
        alias: '',
        name: '',
        active: true
      },
    }
  },

  mounted: function () {
    this.$refs[this.name].show();
    console.log(axios.defaults.headers.common['X-AUTH-TOKEN']);
  },
  methods: {
    close() {
      this.$refs[this.name].hide();
    },
    submit() {
      const _this = this;
      this.busy = true;
      axios.put(`/api/dictionary/${this.form.alias}`,
          {
            name: this.form.name,
            active: this.form.active ? true : false
          }).then(
          () => {
            _this.busy = false;
            _this.close();
            _this.$parent.$emit('refresh-dict');
          }
      )
    }
  }

}

</script>
